// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Vgs4","containerItemsCenter":"Skeleton_containerItemsCenter__3V-PE"};